import { useState, useEffect } from "react";
import useWebInstance from "grandus-lib/hooks/useWebInstance";
import {
  CloseOutlined,
  FrownOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import useCart from "grandus-lib/hooks/useCart";
import get from "lodash/get";
import find from "lodash/find";
import toNumber from "lodash/toNumber";
import isEmpty from "lodash/isEmpty";
import parseInt from "lodash/parseInt";
import map from "lodash/map";
import upperFirst from "lodash/upperFirst";
import EnhancedEcommerce from "utils/ecommerce";
import TagManager from "grandus-lib/utils/gtag";
// import useExpress, { color, expressCategory } from "utils/useExpress";
import { GiftOutlined } from "@ant-design/icons";

import Image from "grandus-lib/components-atomic/image/Image";
import Price from "grandus-lib/components-atomic/price/Price";
import Coupon from "components/cart/Coupon";
import Isic from "components/cart/Isic";
import Steps from "components/cart/steps/CartSteps";
import Link from "next/link";
import CartSummary from "components/cart/summary/CartSummary";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { Table, InputNumber, Button, Row, Col, Result, Typography } from "antd";

const { Paragraph } = Typography;

import styles from "./cart.page.module.scss";
import SalesManago from "utils/salesmanago";
import { useTranslation } from "next-i18next";

const EmptyResult = ({}) => {
  // const { isActive } = useExpress();
  const isActive = () => false;
  const { t } = useTranslation();
  return (
    <div className={"container guttered"}>
      <Result
        icon={<FrownOutlined />}
        title={upperFirst(t("cart:cart is empty"))}
        subTitle={
          isActive()
            ? `${upperFirst(
                t("cart:there are no products in your cart")
              )}, ${upperFirst(
                t(
                  "cart:xpress delivery is activated, so we will prefer products matching this selection"
                )
              )}.`
            : `${upperFirst(t("cart:there are no products in your cart"))}`
        }
        extra={
          // isActive() ? (
          //   <Link
          //     href={"/kategoria/[category]/[[...parameters]]"}
          //     as={"/kategoria/" + expressCategory}
          //     scroll={true}
          //   >
          //     <Button
          //       style={{ color: "black", backgroundColor: color }}
          //       type="primary"
          //     >
          //       {upperFirst(t("cart:select from express delivery products"))}
          //     </Button>
          //   </Link>
          // ) : (
          <Link href="/" as="/">
            <Button type="primary">
              {upperFirst(t("cart:proceed to homepage"))}
            </Button>
          </Link>
          // )
        }
      />
    </div>
  );
};

const BackButton = ({}) => {
  // const { isActive } = useExpress();
  const { t } = useTranslation();
  // const queryObj = {
  //   pathname: "/kategoria/[category]/[[...parameters]]",
  //   query: { category: expressCategory },
  // };
  // if (!isActive) {
  return (
    <Link href="/" as={`/`} scroll={true}>
      <Button type={"text"} icon={<ArrowLeftOutlined />}>
        {t("cart:back to eshop")}
      </Button>
    </Link>
  );
  // }
  // return (
  //   <Link href={queryObj} scroll={true}>
  //     <Button type={"text"} icon={<ArrowLeftOutlined />}>
  //       {t("cart:back to express delivery products")}
  //     </Button>
  //   </Link>
  // );
};

const ItemCountInput = ({ item, itemUpdate, setLoading }) => {
  const storeId = item?.store?.id;
  const productStore = find(get(item, "product.store"), { id: storeId });
  const [count, setCount] = useState(get(item, "count", 1));
  const { webInstance } = useWebInstance();

  if (!get(item, "count")) {
    return "";
  }

  return (
    <>
      {get(item, "measureUnit") ? `1 ${get(item, "measureUnit")} x ` : ""}
      <InputNumber
        className={styles?.amountInput}
        min={1}
        max={
          parseInt(
            get(webInstance, "globalSettings.cart_max_pieces_count", 0)
          ) > 0
            ? parseInt(
                get(webInstance, "globalSettings.cart_max_pieces_count", 0)
              )
            : get(item, "count", 1)
        }
        defaultValue={get(item, "count", 1)}
        value={count}
        onChange={(value) => setCount(value)}
        onBlur={(e) => {
          const value = e.target.value;
          // setLoading(true);
          itemUpdate(item?.id, { count: value }, (cart) => {
            if (cart) {
              const newCount = get(
                find(cart?.items, { id: item?.id }),
                "count",
                1
              );
              setCount(newCount);

              const itemsDifference =
                toNumber(newCount) - toNumber(item?.count);
              if (itemsDifference < 0) {
                TagManager.push(
                  EnhancedEcommerce.cartRemove(
                    item?.product,
                    Math.abs(itemsDifference)
                  )
                );
              } else if (itemsDifference > 0) {
                TagManager.push(
                  EnhancedEcommerce.cartAdd(
                    item?.product,
                    Math.abs(itemsDifference)
                  )
                );
              }
            }
            // setLoading(false);
          });
        }}
      />
      {/* {get(item, "store.name")} */}
    </>
  );
};

const ItemRemove = ({ item, itemRemove, setLoading, style = {} }) => {
  const { t } = useTranslation();
  if (!get(item, "count")) {
    return "";
  }

  return (
    <Button
      style={style}
      type="text"
      className={styles?.removeButton}
      danger
      onClick={(e) => {
        setLoading(true);
        itemRemove(get(item, "id"), () => {
          TagManager.push(
            EnhancedEcommerce.cartRemove(item?.product, get(item, "count", 1))
          );
          setLoading(false);
        });
      }}
    >
      <CloseOutlined />
      <span className={styles?.removeButtonText}>
        {upperFirst(t("common:remove"))}
      </span>
    </Button>
  );
};

const Cart = () => {
  const { t } = useTranslation();
  const { cart, itemRemove, itemUpdate, isLoading } = useCart();
  const [loading, setLoading] = useState(false);

  const isProcessing = isLoading || loading;

  useEffect(() => {
    TagManager.push(EnhancedEcommerce.viewCart(cart));
    SalesManago.checkout(cart, 1);
  }, []);

  if (isEmpty(get(cart, "items", [])) && isProcessing) {
    return (
      <div className={"container guttered"}>
        <Result
          icon={<LoadingOutlined />}
          title={upperFirst(t("cart:shopping cart"))}
          subTitle={upperFirst(t("cart:loading cart"))}
        />
      </div>
    );
  }

  if (isEmpty(get(cart, "items", [])) && !isProcessing) {
    return <EmptyResult />;
  }

  const tableColumns = [
    {
      title: "",
      key: "productImage",
      responsive: ["sm"],
      render: (item) => {
        return (
          <Link
            href="/produkt/[id]"
            as={`/produkt/${get(item, "product.urlTitle")}`}
          >
            <a>
              {get(item, "product.photo") ? (
                <Image
                  photo={get(item, "product.photo")}
                  size={"50x50"}
                  type={"jpg"}
                />
              ) : (
                ""
              )}
            </a>
          </Link>
        );
      },
    },
    {
      title: upperFirst(t("cart:item")),
      key: "productImage",
      render: (item) => {
        return (
          <>
            <Paragraph ellipsis={{ rows: 2 }} style={{ marginBottom: 0 }}>
              <Link
                href="/produkt/[id]"
                as={`/produkt/${get(item, "product.urlTitle")}`}
                scroll={true}
              >
                <a>{get(item, "product.name")}</a>
              </Link>
            </Paragraph>
            <Col xs={24} sm={0}>
              <ItemCountInput
                item={item}
                itemUpdate={itemUpdate}
                setLoading={setLoading}
              />
            </Col>
            {!isEmpty(get(item, "hookedItems")) ? (
              <div className={styles.hook}>
                <GiftOutlined />
                {map(get(item, "hookedItems"), (hook, index) => (
                  <span
                    key={`product-hook-${get(
                      item,
                      "product.urlTitle"
                    )}-${index}`}
                    className={styles.item}
                  >
                    {get(hook, "product.name")}
                  </span>
                ))}
              </div>
            ) : (
              ""
            )}
            {!isEmpty(get(item, "cartHook")) ? (
              <div className={styles.hook}>
                <GiftOutlined />
                <span className={styles.item}>
                  {get(item, "cartHook.name")}
                </span>
              </div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      title: upperFirst(t("cart:amount")),
      responsive: ["md"],
      render: (item) => (
        <ItemCountInput
          item={item}
          itemUpdate={itemUpdate}
          setLoading={setLoading}
        />
      ),
    },
    {
      title: upperFirst(t("cart:availability")),
      responsive: ["md"],
      align: "center",
      render: (item) =>
        item?.product?.storeStatus?.available ? (
          <span className={`${styles.availability} ${styles.available}`}>
            {get(item, "product.storeStatus.message")}
          </span>
        ) : (
          <span
            className={`${styles.availability} ${
              get(item, "product.storeStatus.deliveryDate.date")
                ? styles.arriving
                : styles.unavailable
            }`}
          >
            {get(item, "product.storeStatus.deliveryDate.date")
              ? upperFirst(t("cart:expecting"))
              : ""}{" "}
            {get(item, "product.storeStatus.message")}
          </span>
        ),
    },
    {
      title: upperFirst(t("cart:price")),
      align: "right",
      render: (item) => (
        <>
          {get(item, "priceTotalData.price") ? (
            <b style={{ whiteSpace: "nowrap" }}>
              <Price
                priceData={get(item, "priceTotalData")}
                className={styles?.itemPrice}
              />
            </b>
          ) : (
            <div className={styles.hook}>
              pozornosť od <br /> mobilonline.sk
            </div>
          )}

          <Col xs={24} sm={0} style={{ marginTop: "20px" }}>
            <ItemRemove
              style={{ paddingRight: "0" }}
              item={item}
              itemRemove={itemRemove}
              setLoading={setLoading}
            />
          </Col>
        </>
      ),
    },
    {
      title: "",
      align: "right",
      responsive: ["md"],
      render: (item) => (
        <ItemRemove
          item={item}
          itemRemove={itemRemove}
          setLoading={setLoading}
        />
      ),
    },
  ];

  return (
    <div className={"container guttered"}>
      <Row gutter={[{ xs: 0, sm: 30 }, 10]}>
        <Col xs={24}>
          <Steps current={1} />
        </Col>
        <Col xs={24}>
          <Table
            loading={
              loading
                ? { indicator: <LoadingOutlined style={{ fontSize: "4em" }} /> }
                : false
            }
            pagination={false}
            columns={tableColumns}
            dataSource={[
              ...get(cart, "items", []),
              ...get(cart, "extraItems", []),
            ]}
            rowKey={(record) => (record?.id ? record?.id : record?.product?.id)}
            className={styles.cartItemsTable}
          />
        </Col>
        <Col xs={{ span: 24, order: 2 }} md={{ span: 14, order: 1 }}>
          <Coupon className={styles?.coupon} />
          <Isic className={styles?.primaryCard} />
        </Col>
        <Col xs={{ span: 24, order: 1 }} md={{ span: 10, order: 2 }}>
          <CartSummary
            title={null}
            showProducts={false}
            actions={[
              <BackButton />,
              <Link href="/kosar/kapcsolat" as={`/kosar/kapcsolat`} scroll={true}>
                <Button
                  size={"large"}
                  disabled={loading}
                  className={styles?.buttonSecondary}
                >
                  {upperFirst(t("cart:proceed to checkout"))}
                </Button>
              </Link>,
            ]}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Cart;

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "cart"])),
    },
  };
}
